import {INativeStyleDeclaration} from "@webfruits/core/dist/interface/INativeStyleDeclaration";
import {Size} from "./Size";

/******************************************************************
 * Font
 *
 * @author matthias.schulz@jash.de
 *****************************************************************/

export class Font {

    /******************************************************************
     * FONT FAMILY
     *****************************************************************/

    static readonly HELVETICA_REGULAR = "HelveticaNeue"
    static readonly HELVETICA_BOLD = "HelveticaNeue-Bold"

    /******************************************************************
     * FONT STYLES
     *****************************************************************/

    static get H1_FONTSTYLE(): INativeStyleDeclaration {
        return {
            fontFamily: Font.HELVETICA_BOLD,
            fontSize: Size.calcResponsiveValue(24, 35),
            lineHeight: Size.calcResponsiveValue(24, 35)
        };
    }

    static get H2_FONTSTYLE(): INativeStyleDeclaration {
        return {
            fontFamily: Font.HELVETICA_BOLD,
            fontSize: Size.calcResponsiveValue(20, 25),
            lineHeight: Size.calcResponsiveValue(22, 28)
        };
    }

    static get P_FONTSTYLE(): INativeStyleDeclaration {
        return {
            fontFamily: Font.HELVETICA_REGULAR,
            fontSize: Size.calcResponsiveValue(16, 20),
            lineHeight: Size.calcResponsiveValue(22, 30)
        };
    }

    static get P_SMALL_FONTSTYLE(): INativeStyleDeclaration {
        return {
            fontFamily: Font.HELVETICA_REGULAR,
            fontSize: Size.calcResponsiveValue(12, 14),
            lineHeight: Size.calcResponsiveValue(17, 20)
        };
    }

    static get P_STRONG_FONTSTYLE(): INativeStyleDeclaration {
        return {
            fontFamily: Font.HELVETICA_BOLD,
        };
    }

    static get P_SMALL_STRONG_FONTSTYLE(): INativeStyleDeclaration {
        return {
            fontFamily: Font.HELVETICA_BOLD,
        };
    }

    static get FOOTNOTE_FONTSTYLE(): INativeStyleDeclaration {
        return {
            fontFamily: Font.HELVETICA_REGULAR,
            fontSize: Size.calcResponsiveValue(6, 8),
            lineHeight: Size.calcResponsiveValue(8, 10)
        };
    }

}
